import { render, staticRenderFns } from "./SafetyInstructions.vue?vue&type=template&id=8c7dfa34&"
import script from "./SafetyInstructions.vue?vue&type=script&lang=js&"
export * from "./SafetyInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports